import * as React from 'react';
import type { GDSIconProps } from '@leagueplatform/genesis-core';
import { Box, Icon } from '@leagueplatform/genesis-core';
import { LinkableCell } from '../table-pieces.component';

export type IconCellProps = {
  icon?: GDSIconProps['icon'];
  linkTo?: string;
};

export const IconCell: React.FC<IconCellProps> = ({ icon, linkTo }) => {
  if (!icon) return null;

  return (
    <LinkableCell linkTo={linkTo}>
      <Box
        css={{
          height: '$twoAndHalf',
          width: '$twoAndHalf',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          borderRadius: '$small',
          color: '$icon',
        }}
      >
        <Icon tint="$onSurfaceIconPrimary" icon={icon} />
      </Box>
    </LinkableCell>
  );
};
